/**
 * Tile provider abstraction.
 * Swap providers without touching any component code.
 */
import L from 'leaflet';

export const TILE_PROVIDERS = {
  osm: {
    url:         'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom:     19,
  },
  carto: {
    url:         'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
    attribution: '&copy; <a href="https://carto.com/">Carto</a>',
    maxZoom:     19,
  },
  satellite: {
    url:         'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Tiles &copy; Esri',
    maxZoom:     18,
  },
  terrain: {
    url:         'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://opentopomap.org">OpenTopoMap</a>',
    maxZoom:     17,
  },
};

/**
 * Create a Leaflet tile layer for the given provider id.
 * Falls back to OSM if the provider id is unknown.
 * @param {string} providerId - 'osm' | 'carto' | 'satellite' | 'terrain'
 * @returns {L.TileLayer}
 */
export function createTileLayer(providerId = 'osm') {
  const provider = TILE_PROVIDERS[providerId] || TILE_PROVIDERS.osm;
  return L.tileLayer(provider.url, {
    attribution: provider.attribution,
    maxZoom:     provider.maxZoom,
  });
}
